<template>
  <rest-list :payload="fetchEndpoint" @dataLoaded="setData($event)">
    <template v-if="data[0]">
      <rest-list-column
        prop="type"
        :title="$t('CampaignChannelAnalytics_Table_Bounces')"
      />
      <rest-list-column
        prop="metrics[0].value"
        :title="$t('CampaignChannelAnalytics_Table_Amount')"
        :filter-input="false"
        :width="200"
      />
    </template>
  </rest-list>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'DeliveryFailures',
  components: { RestListColumn, RestList },
  props: {
    channel: {
      type: String,
      required: true
    },

    analyticsDateRange: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      data: []
    }
  },

  computed: {
    campaignId() {
      return this.$route.query.id || null
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.campaignId}/analytics/${this.channel}/bounces`,
        params: {
          date_from: this.analyticsDateRange.date_from,
          date_to: this.analyticsDateRange.date_to
        }
      })
    }
  },

  methods: {
    setData(event) {
      if (event.length) {
        this.data = event
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/analytics/DeliveryFailures.vue